
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_p8a6i_16osi_141",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_16osi_173",
  "header-refresh": "awsui_header-refresh_p8a6i_16osi_173",
  "list": "awsui_list_p8a6i_16osi_180",
  "list-grid-1": "awsui_list-grid-1_p8a6i_16osi_191",
  "card": "awsui_card_p8a6i_16osi_191",
  "list-grid-2": "awsui_list-grid-2_p8a6i_16osi_194",
  "list-grid-3": "awsui_list-grid-3_p8a6i_16osi_197",
  "list-grid-4": "awsui_list-grid-4_p8a6i_16osi_200",
  "list-grid-5": "awsui_list-grid-5_p8a6i_16osi_203",
  "list-grid-6": "awsui_list-grid-6_p8a6i_16osi_206",
  "list-grid-7": "awsui_list-grid-7_p8a6i_16osi_209",
  "list-grid-8": "awsui_list-grid-8_p8a6i_16osi_212",
  "list-grid-9": "awsui_list-grid-9_p8a6i_16osi_215",
  "list-grid-10": "awsui_list-grid-10_p8a6i_16osi_218",
  "list-grid-11": "awsui_list-grid-11_p8a6i_16osi_221",
  "list-grid-12": "awsui_list-grid-12_p8a6i_16osi_224",
  "list-grid-13": "awsui_list-grid-13_p8a6i_16osi_227",
  "list-grid-14": "awsui_list-grid-14_p8a6i_16osi_230",
  "list-grid-15": "awsui_list-grid-15_p8a6i_16osi_233",
  "list-grid-16": "awsui_list-grid-16_p8a6i_16osi_236",
  "list-grid-17": "awsui_list-grid-17_p8a6i_16osi_239",
  "list-grid-18": "awsui_list-grid-18_p8a6i_16osi_242",
  "list-grid-19": "awsui_list-grid-19_p8a6i_16osi_245",
  "list-grid-20": "awsui_list-grid-20_p8a6i_16osi_248",
  "selection-control": "awsui_selection-control_p8a6i_16osi_252",
  "loading": "awsui_loading_p8a6i_16osi_262",
  "empty": "awsui_empty_p8a6i_16osi_263",
  "has-header": "awsui_has-header_p8a6i_16osi_270",
  "refresh": "awsui_refresh_p8a6i_16osi_273",
  "card-header": "awsui_card-header_p8a6i_16osi_289",
  "card-header-inner": "awsui_card-header-inner_p8a6i_16osi_298",
  "card-header-inner-selectable": "awsui_card-header-inner-selectable_p8a6i_16osi_301",
  "card-selected": "awsui_card-selected_p8a6i_16osi_304",
  "section": "awsui_section_p8a6i_16osi_308",
  "section-header": "awsui_section-header_p8a6i_16osi_315",
  "section-content": "awsui_section-content_p8a6i_16osi_321",
  "footer-pagination": "awsui_footer-pagination_p8a6i_16osi_333"
};
  